import Vue from 'vue';
import VueToasted from 'vue-toasted';
import AsyncComputed from 'vue-async-computed';
import PrimaryButton from '@/components/buttons/PrimaryButton';
import ConfirmButton from '@/components/buttons/ConfirmButton';
import CancelButton from '@/components/buttons/CancelButton';

Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.performance = process.env.NODE_ENV !== 'production';

Vue.use(VueToasted, {
  position: 'bottom-right',
  duration: 3000,
  iconPack: 'materials',
  theme: 'toasted-primary',
  className: 'toasty'
});

Vue.use(AsyncComputed);

Vue.component('PrimaryButton', PrimaryButton);
Vue.component('ConfirmButton', ConfirmButton);
Vue.component('CancelButton', CancelButton);
